import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LandingLayout from '@/pages/Landing/LandingLayout';
import NotFound from '@/pages/NotFound/NotFound';
import App from './App';
import Support from '@/pages/Support/Support';
import TermsConditions from '@/pages/TermsConditions/TermsConditions';
import PrivacyPolicy from '@/pages/PrivacyPolicy/PrivacyPolicy';
import CreditOperation from '@/pages/CreditOperation/CreditOperation';
import MagicLink from './pages/Redirect/MagicLink';
import Recovery from './pages/Redirect/Recovery';
import Verify from './pages/Redirect/Verify';
import Login from '@/pages/Redirect/Login';

const Router: React.FC = () => {
	const router = createBrowserRouter([
		{
			path: '/',
			element: <App />,
			errorElement: <NotFound />,
			children: [
				{
					index: true,
					element: <LandingLayout />
				},
				{
					path: 'support',
					element: <Support />
				},
				{
					path: 'terms-conditions',
					element: <TermsConditions />
				},
				{
					path: 'privacy',
					element: <PrivacyPolicy />
				},
				{
					path: 'credit-operation',
					element: <CreditOperation />
				}
			]
		},
		{
			path: '/:open',
			children: [
				{
					path: 'recovery',
					element: <Recovery />
				},
				{
					path: 'verify',
					element: <Verify />
				}
			]
		},
		{
			path: 'onboarding/np/magic-link',
			element: <MagicLink />
		}
	]);
	return <RouterProvider router={router} />;
};

export default Router;
